export const NOT_STARTED = 'NOT_STARTED'
export const IN_PROGRESS = 'IN_PROGRESS'
export const COMPLETE = 'COMPLETE'
export const ERROR = 'ERROR'

export default { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR }
